import { TextFieldProps } from '@mui/material'
import { ScreenEnum, useScreen } from 'feature/screenMode'

export const useDadataTextFieldProps = (inputProps: TextFieldProps) => {
  const {
    required,
    InputProps: inputPropsInputProps,
    ...textFieldProps
  } = inputProps

  const screen = useScreen()

  const computedTextFieldProps = {
    ...textFieldProps,
    multiline: textFieldProps.multiline ?? true,
    maxRows: textFieldProps.maxRows ?? (screen !== ScreenEnum.desktop ? 10 : 2),
  }

  return {
    computedTextFieldProps,
    inputPropsInputProps,
    required,
  }
}
